import React from 'react';
import { withAuth0 } from '@auth0/auth0-react';
import { CookieWrapper } from '../helpers/shared-variables';
import PropTypes from 'prop-types';

const Logout = ( props ) => {
	CookieWrapper.remove( 'token', { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: '/' } );
	window.localStorage.clear();
	props.auth0.logout();
	window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/auth/logout`;
	return ( <></> );
};

Logout.propTypes = {
	auth0: PropTypes.object,
};

export default withAuth0( Logout );
